module.exports = __webpack_public_path__ + "static/cultist-543083a88e849c3d8e83f68cfc15b61a.png";